/*! fw-store-request.js — "Bring it to your shop" (Lance 2026-10-31). No dependencies.
 * 1) When the shop the shopper names already carries Fragile What, or a shop in the same state already carries this pair, the form says
 *    so: a note, never a block (the board's "offer it only when no shop nearby carries it", built soft — Slider-Page RULES 2026-10-31).
 *    The note is also copied into the email ("Already carried") so the referral check sees it.
 * 2) Product pages: the pair in the email is the variant the shopper has picked when they send it (Upcycled Paperboard FW… or
 *    Birch Wood FW…-BW), not the one the page loaded with (review 2026-10-31).
 * Store rows: a .fwr-data JSON [[name, city, state, carriesThisPair], …] (product pages, from the shop metafield) or
 * wrap.__fwrData() → [{n, c, s, carry}] (the Xhale offer screen and test themes, from the same data).
 * Variants: a .fwr-variants JSON [[id, sku, title], …] (product pages only).
 */
(function () {
  'use strict';
  var NAMES = { AL: 'alabama', AK: 'alaska', AZ: 'arizona', AR: 'arkansas', CA: 'california', CO: 'colorado', CT: 'connecticut',
    DE: 'delaware', DC: 'district of columbia', FL: 'florida', GA: 'georgia', HI: 'hawaii', ID: 'idaho', IL: 'illinois', IN: 'indiana',
    IA: 'iowa', KS: 'kansas', KY: 'kentucky', LA: 'louisiana', ME: 'maine', MD: 'maryland', MA: 'massachusetts', MI: 'michigan',
    MN: 'minnesota', MS: 'mississippi', MO: 'missouri', MT: 'montana', NE: 'nebraska', NV: 'nevada', NH: 'new hampshire',
    NJ: 'new jersey', NM: 'new mexico', NY: 'new york', NC: 'north carolina', ND: 'north dakota', OH: 'ohio', OK: 'oklahoma',
    OR: 'oregon', PA: 'pennsylvania', RI: 'rhode island', SC: 'south carolina', SD: 'south dakota', TN: 'tennessee', TX: 'texas',
    UT: 'utah', VT: 'vermont', VA: 'virginia', WA: 'washington', WV: 'west virginia', WI: 'wisconsin', WY: 'wyoming', PR: 'puerto rico' };
  // longest names first, so "west virginia" is never read as "virginia"
  var BYLEN = Object.keys(NAMES).sort(function (a, b) { return NAMES[b].length - NAMES[a].length; });

  // shop names: lower case, "&" = "and", no apostrophes or punctuation, no "the" / "inc" / "llc" / "co"
  function norm(s) {
    return String(s || '').toLowerCase().replace(/&/g, ' and ').replace(/['’`]/g, '').replace(/[^a-z0-9]+/g, ' ')
      .replace(/\b(the|inc|llc|co|ltd|corp)\b/g, ' ').replace(/\s+/g, ' ').trim();
  }
  // the state at the end of an address: "..., Gig Harbor, WA 98335" / "... Washington 98335" / "…, Washington, D.C." → "WA" / "DC"
  function stateOf(addr) {
    var t = String(addr || '').toLowerCase().replace(/\b\d{5}(-\d{4})?\b/g, ' ').replace(/[^a-z]+/g, ' ').trim();
    t = t.replace(/\s*\b(u s a|usa|u s|us|united states( of america)?)$/, '').trim();
    if (!t) return '';
    if (/\bd c$/.test(t) || /(^|\s)dc$/.test(t)) return 'DC';
    var m = /(^|\s)([a-z]{2})$/.exec(t);
    if (m && NAMES[m[2].toUpperCase()]) return m[2].toUpperCase();
    for (var i = 0; i < BYLEN.length; i++) {
      var k = BYLEN[i], n = NAMES[k];
      if (t.length >= n.length && t.slice(-n.length) === n && (t.length === n.length || t.charAt(t.length - n.length - 1) === ' ')) return k;
    }
    return '';
  }
  function where(r) { return (r.c ? r.c + ', ' : '') + r.s; }
  function rows(wrap) {
    if (typeof wrap.__fwrData === 'function') { try { return wrap.__fwrData() || []; } catch (e) { return []; } }
    if (!wrap.__fwrRows) {
      var j = wrap.querySelector('.fwr-data'), out = [];
      try { out = JSON.parse(j ? j.textContent : '[]').map(function (r) { return { n: r[0], c: r[1], s: r[2], carry: !!r[3] }; }); } catch (e) { out = []; }
      wrap.__fwrRows = out;
    }
    return wrap.__fwrRows;
  }
  // the named shop is a store on the list when the names are the same, or one name is the other plus more words AND the store's
  // city is in the typed address ("Magpie" ≠ "Magpie Books" in another town)
  function sameShop(r, nn, addrN) {
    var k = norm(r.n);
    if (k.length < 4) return false;
    if (k === nn) return true;
    var longer = nn.length > k.length ? nn : k, shorter = nn.length > k.length ? k : nn;
    if (shorter.length < 6 || longer.indexOf(shorter + ' ') !== 0) return false;
    var city = norm(r.c);
    return !!city && (' ' + addrN + ' ').indexOf(' ' + city + ' ') >= 0;
  }
  function note(wrap) {
    var form = wrap.querySelector('form'); if (!form) return '';
    var nameIn = form.querySelector('[name="contact[Shop name]"]'), addrIn = form.querySelector('[name="contact[Shop address]"]');
    var list = rows(wrap), nn = norm(nameIn && nameIn.value), addr = addrIn ? addrIn.value : '', st = stateOf(addr), addrN = norm(addr), msg = '';
    if (nn.length >= 4) {
      var hit = list.filter(function (r) { return (!st || r.s === st) && sameShop(r, nn, addrN); })[0];
      if (hit) msg = hit.n + ' in ' + where(hit) + (hit.carry ? ' already carries this pair.' : ' already carries Fragile What.');
    }
    if (!msg && st) {
      var near = list.filter(function (r) { return r.carry && r.s === st; });
      if (near.length) {
        msg = 'Good news: ' + near.slice(0, 2).map(function (r) { return r.n + ' in ' + where(r); }).join(' and ') +
          (near.length > 2 ? ' and ' + (near.length - 2) + ' more' : '') + (near.length === 1 ? ' already carries' : ' already carry') + ' this pair.';
      }
    }
    return msg;
  }
  function check(wrap) {
    var hint = wrap.querySelector('.fwr-hint'), keep = wrap.querySelector('[name="contact[Already carried]"]');
    if (!hint) return;
    var msg = note(wrap);
    hint.textContent = msg; hint.hidden = !msg;
    if (keep) keep.value = msg;
  }
  // product pages: which variant is picked now — the URL's ?variant=, else the page's own product form, else the first one
  function pickedVariant(wrap) {
    var j = wrap.querySelector('.fwr-variants'); if (!j) return null;
    var vs; try { vs = JSON.parse(j.textContent); } catch (e) { return null; }
    if (!vs.length) return null;
    var ids = vs.map(function (v) { return String(v[0]); });
    // the page's own product form: the [name=id] whose value is one of THIS product's variants (quick-add forms elsewhere are skipped);
    // the theme sets it from code with no change event, so it is read fresh every time
    var f = Array.prototype.filter.call(document.querySelectorAll('form[action*="/cart/add"] [name="id"]'), function (x) {
      return !wrap.contains(x) && ids.indexOf(String(x.value)) >= 0;
    })[0];
    var id = f ? f.value : (/[?&]variant=(\d+)/.exec(location.search) || [])[1];
    for (var i = 0; i < vs.length; i++) if (String(vs[i][0]) === String(id)) return vs[i];
    return vs[0];
  }
  function syncVariant(wrap) {
    var v = pickedVariant(wrap), e = wrap.querySelector('[name="contact[Earrings]"]');
    if (!v || !e) return;
    var base = e.getAttribute('data-title') || '', many = +(e.getAttribute('data-variants') || 1) > 1;
    e.value = base + (many && v[2] ? ' | ' + v[2] : '') + ' (' + v[1] + ')';
  }
  function attach(wrap) {
    if (wrap.__fwrOn) return; wrap.__fwrOn = true;
    var t = null;
    wrap.addEventListener('input', function (e) {
      var n = e.target && e.target.name;
      if (n !== 'contact[Shop name]' && n !== 'contact[Shop address]') return;
      clearTimeout(t); t = setTimeout(function () { check(wrap); }, 250);
    });
    wrap.addEventListener('change', function () { check(wrap); });
    var form = wrap.querySelector('form');
    if (form) form.addEventListener('submit', function () { check(wrap); syncVariant(wrap); }, true);
    if (wrap.querySelector('.fwr-variants')) {
      // the theme's variant picker: a radio change, then its own variant:selected / variant:update events (review 2026-10-31);
      // follow all three (the submit handler reads it again anyway)
      // read it again a moment later too: the theme sometimes switches the material a little after the click (seen 2026-10-31)
      var later = function () { [60, 450, 1200].forEach(function (ms) { setTimeout(function () { syncVariant(wrap); }, ms); }); };
      document.addEventListener('change', function (e) { if (!wrap.contains(e.target)) later(); }, true);
      document.addEventListener('variant:update', later); document.addEventListener('variant:selected', later);
      syncVariant(wrap);
    }
    // after a real send, take contact_posted off the address so a reload or a shared link never shows "Got it" to someone else
    if (wrap.querySelector('.fwr-ok') && /[?&]contact_posted=true/.test(location.search) && window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.delete('contact_posted'); if (/^#fw-store-request/.test(u.hash)) u.hash = '';
      history.replaceState(history.state, '', u.pathname + (u.search || '') + u.hash);
    }
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('.fwr'), attach); }
  window.__fwr = { check: check, note: note, stateOf: stateOf, norm: norm, syncVariant: syncVariant };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
})();
